var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2005 9.95959C9.96037 9.0021 9.30359 8.34533 8.34611 4.10523C8.30224 3.91144 8.12974 3.77344 7.9304 3.77344C7.73107 3.77344 7.55857 3.91144 7.5147 4.10523C6.55679 8.34533 5.90044 9.0021 1.66035 9.95959C1.46612 10.0039 1.32812 10.176 1.32812 10.3753C1.32812 10.5746 1.46612 10.7467 1.66035 10.791C5.90044 11.7489 6.55679 12.4057 7.5147 16.6453C7.55857 16.8391 7.73107 16.9771 7.9304 16.9771C8.12974 16.9771 8.30224 16.8391 8.34611 16.6453C9.30401 12.4057 9.96037 11.7489 14.2005 10.791C14.3947 10.7467 14.5323 10.5746 14.5323 10.3753C14.5323 10.176 14.3943 10.0039 14.2005 9.95959Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0346 3.35222C15.7806 2.84324 15.4641 2.52678 14.9551 0.273202C14.9108 0.0789803 14.7387 -0.0585938 14.5394 -0.0585938C14.3401 -0.0585938 14.168 0.0789803 14.1237 0.273202C13.6147 2.52678 13.2983 2.84324 11.0447 3.35222C10.8505 3.39652 10.7129 3.56859 10.7129 3.76793C10.7129 3.96726 10.8505 4.13933 11.0447 4.18363C13.2983 4.69261 13.6147 5.00907 14.1237 7.26307C14.168 7.45687 14.3401 7.59487 14.5394 7.59487C14.7387 7.59487 14.9108 7.45687 14.9551 7.26307C15.4641 5.00907 15.7806 4.69261 18.0346 4.18363C18.2284 4.13933 18.3664 3.96726 18.3664 3.76793C18.3664 3.56859 18.2284 3.39652 18.0346 3.35222Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars2);
export default __webpack_public_path__ + "static/media/stars-2.21770405cf5012cf2319455c961e9fe5.svg";
export { ForwardRef as ReactComponent };